import { CommercialApiContract } from "@/contracts/CommercialApiContract";

export const CommercialApiConfig: CommercialApiContract = {

	endpoint: `${process.env.VUE_APP_MOE_COMMERCIAL_API_URL}`,

	//should this go in .env file as well?
	pageSize: 20,
}